export const config = {
    rating: {
        ratingSubmittionDelay: 500,
    },
}